import axios from 'utils/axios'

export const MAPA_ENDERECO = 'MAPA_ENDERECO'

export const buscarEndereco = (value) => ({
  type: 'MAPA_ENDERECO',
  dados: value,
})

export const listarCidadesRN = (setCidades) => async () => {
  const response = await axios.get(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/RN/municipios`
  )
  setCidades(response.data)
}
